const steps = [
  {
    number: '01',
    title: 'Initial Application Review',
    description:
      'Every prospective tenant completes a comprehensive application. We review employment history, rental history, and personal references before proceeding to deeper verification.',
  },
  {
    number: '02',
    title: 'Financial Verification',
    description:
      'We conduct thorough income verification, credit analysis, and financial stability assessments to ensure tenants can comfortably meet their obligations.',
  },
  {
    number: '03',
    title: 'Background & Reference Checks',
    description:
      'Detailed background screening including criminal history, eviction records, and direct contact with previous landlords and professional references.',
  },
  {
    number: '04',
    title: 'Final Approval & Placement',
    description:
      'Only candidates who meet our exacting standards are presented to property owners. We provide a full summary report and recommendation before any placement is confirmed.',
  },
];

export default function TenantScreening() {
  return (
    <section id="tenant-screening" className="w-full bg-[#2C2C2C] py-28 px-6 md:px-16">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          {/* Left */}
          <div className="lg:w-2/5">
            <span className="text-xs uppercase tracking-[0.25em] text-[#C9A961] font-semibold">
              — Tenant Screening
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold text-white mt-5 mb-6 leading-tight">
              Only the Most Qualified Tenants
            </h2>
            <p className="text-white/65 text-base font-light leading-relaxed mb-10">
              Our multi-layered screening process is designed to protect your investment and ensure a harmonious tenancy. We leave nothing to chance.
            </p>
            <div className="relative w-full h-64 lg:h-80 rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/f04180e8e5c32e916ecd4b39c8aeb4de.jpg"
                alt="Tenant Screening Process"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
          </div>

          {/* Right - Timeline */}
          <div className="lg:w-3/5 flex flex-col gap-10">
            {steps.map((step, index) => (
              <div key={step.number} className="flex gap-6">
                <div className="flex flex-col items-center">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full border border-[#C9A961] flex-shrink-0">
                    <span className="text-[#C9A961] text-xs font-semibold">{step.number}</span>
                  </div>
                  {index < steps.length - 1 && (
                    <div className="w-px flex-1 bg-white/15 mt-3"></div>
                  )}
                </div>
                <div className="pb-10">
                  <h3 className="text-lg font-semibold text-white mb-3">{step.title}</h3>
                  <p className="text-white/60 text-sm font-light leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
